var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4301_5773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0H26.25C28.32 0 30 1.68 30 3.75V26.25C30 27.2446 29.6049 28.1984 28.9016 28.9016C28.1984 29.6049 27.2446 30 26.25 30H3.75C2.75544 30 1.80161 29.6049 1.09835 28.9016C0.395088 28.1984 0 27.2446 0 26.25V3.75C0 1.68 1.68 0 3.75 0Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 20.4444C8.64294 20.4444 8.42038 20.5264 8.25628 20.6722C8.09219 20.8181 8 21.0159 8 21.2222C8 21.4285 8.09219 21.6263 8.25628 21.7722C8.42038 21.9181 8.64294 22 8.875 22H21.125C21.3571 22 21.5796 21.9181 21.7437 21.7722C21.9078 21.6263 22 21.4285 22 21.2222C22 21.0159 21.9078 20.8181 21.7437 20.6722C21.5796 20.5264 21.3571 20.4444 21.125 20.4444H8.875ZM19.3313 14.4532C19.25 14.3809 19.1535 14.3235 19.0473 14.2844C18.941 14.2453 18.8272 14.2251 18.7122 14.2251C18.5972 14.2251 18.4833 14.2453 18.3771 14.2844C18.2709 14.3235 18.1744 14.3809 18.0931 14.4532L15.875 16.4257V8.77778C15.875 8.5715 15.7828 8.37367 15.6187 8.22781C15.4546 8.08194 15.2321 8 15 8C14.7679 8 14.5454 8.08194 14.3813 8.22781C14.2172 8.37367 14.125 8.5715 14.125 8.77778V16.4257L11.906 14.4532C11.7418 14.3074 11.5192 14.2255 11.2871 14.2256C11.055 14.2256 10.8324 14.3077 10.6683 14.4536C10.5042 14.5996 10.4121 14.7975 10.4122 15.0038C10.4123 15.2101 10.5046 15.4079 10.6688 15.5538L14.3814 18.8531C14.5455 18.9989 14.768 19.0808 15 19.0808C15.232 19.0808 15.4545 18.9989 15.6186 18.8531L19.3313 15.5538C19.4126 15.4815 19.4771 15.3958 19.5212 15.3013C19.5652 15.2069 19.5879 15.1057 19.5879 15.0035C19.5879 14.9013 19.5652 14.8001 19.5212 14.7057C19.4771 14.6112 19.4126 14.5255 19.3313 14.4532Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4301_5773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHover);
export default __webpack_public_path__ + "static/media/download-hover.010c563225f7164b605ed9e7905ea3ff.svg";
export { ForwardRef as ReactComponent };